import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-scroll'
import classNames from 'classnames'
import './nav.css'

const scrollDuration = 500

const NavLink = ({target, label, onClickHandler}) => {
  return (
    <Link
      to={target}
      smooth={true}
      duration={scrollDuration}
      onClick={onClickHandler}
      className="nav-link"
    >
      {label}
    </Link>
  )
}

const NavLinks = ({items, onClickHandler}) => (
  <ul>
    {items.map(item => (
      <li key={item.target}>
        <NavLink
          target={item.target}
          label={item.label}
          onClickHandler={onClickHandler}
        />
      </li>
    ))}
  </ul>
)

class Nav extends Component {
  constructor() {
    super()
    this.state = {
      mobileNavDisplayed: false,
    }
    this.toggleNav = this.toggleNav.bind(this)
    this.hideMobileNavMenu = this.hideMobileNavMenu.bind(this)
  }

  toggleNav() {
    let newMobileNavDisplayedState = !this.state.mobileNavDisplayed
    if (newMobileNavDisplayedState) {
      document.body.classList.add('mobile-nav-displayed')
    } else {
      document.body.classList.remove('mobile-nav-displayed')
    }
    this.setState({
      mobileNavDisplayed: newMobileNavDisplayedState,
    })
  }

  hideMobileNavMenu() {
    document.body.classList.remove('mobile-nav-displayed')
    this.setState({
      mobileNavDisplayed: false,
    })
  }

  render() {
    const containerClass = classNames({
      'mobile-nav-toggle-active': this.state.mobileNavDisplayed,
    })
    const mobileNavToggleClass = classNames('mobile-nav-toggle', {
      on: this.state.mobileNavDisplayed,
    })
    const mobileNavToggleIcon = this.state.mobileNavDisplayed ? (
      <span>&#10005;</span>
    ) : (
      <span>&#9776;</span>
    )
    const mobileNavMenuClass = classNames('mobile-nav', {
      visible: this.state.mobileNavDisplayed,
    })
    const toggleNav = this.toggleNav
    const hideMobileNavMenu = this.hideMobileNavMenu

    return (
      <div className={containerClass}>
        <nav className={mobileNavMenuClass}>
          <NavLinks
            items={this.props.items}
            onClickHandler={hideMobileNavMenu}
          />
        </nav>
        <div className={mobileNavToggleClass}>
          <a className="mobile-nav-toggle-icon" onClick={toggleNav}>
            {mobileNavToggleIcon}
          </a>
        </div>
        <nav className="desktop-nav">
          <NavLinks items={this.props.items} />
        </nav>
        {this.props.children}
      </div>
    )
  }
}
Nav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js